import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const PdfViewer = () => {
  const { id } = useParams();
  const [pdf, setPdf] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const res = await axios.get(`/api/public/pdfs/${id}`);
        setPdf(res.data);
      } catch (err) {
        setError("PDF not found or deleted");
      } finally {
        setLoading(false);
      }
    };
    fetchPdf();
  }, [id]);

  if (loading) return <div className="text-center p-8">Loading...</div>;
  if (error) return <div className="text-center text-red-500 p-8">{error}</div>;

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-100 p-6">
      <h1 className="text-2xl font-semibold mb-4">{pdf.title || "Menu PDF"}</h1>

      <iframe
        src={pdf.url}
        title="PDF Viewer"
        width="80%"
        height="600"
        className="shadow-lg border rounded-lg bg-white mb-6"
      />

      <div className="flex gap-4">
        <a
          href={pdf.url}
          download
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Download PDF
        </a>

        <a
          href={pdf.url}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
        >
          View in Browser
        </a>

        <Link
          to="/middaydiscount"
          className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500"
        >
          Back
        </Link>
      </div>
    </div>
  );
};

export default PdfViewer;
